export default () => {
  const contactListSection = document.querySelectorAll('.contact-list');
  
  if (!contactListSection) {
    return;
  }

  contactListSection.forEach(section => {
    const contactListExpandBtn = section.querySelector('.expand-all'),
          collapseButtons = section.querySelectorAll('.accordion-button');

    contactListExpandBtn?.addEventListener('click', () => {
      collapseButtons.forEach(item => {
        item.click();
      });
    })
  })
}